var jade = require("C:\\Users\\kopperts\\Repos\\node_modules\\webpack\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var self = locals || {};
buf.push("<p>" + (jade.escape(null == (jade_interp = typeof abc === "undefined" ? "self" + self.abc : abc) ? "" : jade_interp)) + "</p>" + (null == (jade_interp = require("C:\\Users\\kopperts\\Repos\\node_modules\\webpack\\test\\cases\\loaders\\_resources\\included.jade").call(this, locals)) ? "" : jade_interp));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/jade-loader?self!./loaders/_resources/template.jade
 ** module id = 1
 ** module chunks = 0
 **/